import { render } from "./AddCase.vue?vue&type=template&id=cea3f6ba&scoped=true"
import script from "./AddCase.vue?vue&type=script&lang=js"
export * from "./AddCase.vue?vue&type=script&lang=js"

import "./AddCase.vue?vue&type=style&index=0&id=cea3f6ba&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea3f6ba"]])

export default __exports__